var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Badge',{attrs:{"value":_vm.label,"theme":_vm.theme}})
}
var staticRenderFns = []

export { render, staticRenderFns }